import React, { useContext, useState } from 'react';
import { Layout, Menu, Row } from "antd";
import styles from './MenuLayout.module.scss'
import { requestIcon } from "../../pages/Profile/Request/request.utils.props";
import { useTranslation } from "react-i18next";
import { AppContext } from 'src/pages/context/App.context';
import _ from 'lodash';
import * as FriendAPI from "../../service/friend.service";
import useFetch, { CachePolicies } from "use-http";

const { Header, Content, Footer, Sider } = Layout

interface MyCenterMenuLayoutProps {
    headerPostfix?: React.ReactElement
}

const MyCenterMenuLayout: React.FunctionComponent<MyCenterMenuLayoutProps> = (props) => {
    const { children } = props
    const appCtx: any = useContext(AppContext);
    const [timer, setTimer] = useState(null);
    const callLimit = 30;
    const reportLimit = 10;
    const [reportedHistory, setReportedHistory] = useState<any[]>([]);

    const blockAccount = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/users/all/block-account`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );
    const reportAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/report/?type=user`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );
    const { t } = useTranslation();
    const searchFriends = (event: any) => {
        const value = event.target.value;
        clearTimeout(timer!);
        setTimer(
            //@ts-ignore
            setTimeout(async () => {
                
                if (appCtx.tabsFriends === null || appCtx.tabsFriends === "Friends") {
                    const loadMyFriend = async (
                        search: string,
                        limit: number,
                        offset: number
                    ) => {
                        const { data } = await FriendAPI.findMyFriend(search, limit, offset);
                        return data;
                    };
                    const data = await loadMyFriend(value, callLimit, 0);                    
                    if (!_.isEmpty(data)) {
                        appCtx.setMyFriends(data);
                    } else {
                        appCtx.setMyFriends(appCtx.myFriends);
                    }
                }
                if (appCtx.tabsFriends === "Blocked Accounts") {
                    // const data = await blockAccount.get(``);
                    // console.log("daata", data);
                    
                    // if (value !== "") {
                    //     let filter = data.filter((item: any) => {
                    //         console.log("item.friendIDs", item);
                    //         return item.friend?.firstname.includes(value.toLowerCase());
                    //     })
                    //     appCtx.setMyBlockAccount(filter);
                    // } else {
                    //     appCtx.setMyBlockAccount( appCtx.setMyBlockAccount); 
                    // }
                    // const loadMyฺBlockFriends = async (
                    //     search: string,
                    //     limit: number,
                    //     offset: number
                    // ) => {
                    //     const { data } = await FriendAPI.findMyฺBlockFriends(search, limit, offset);console.log("search",search);
                    //     return data;
                    // };
                    // const data = await loadMyฺBlockFriends(appCtx.search, callLimit, 0);
                    // console.log("dataFriendblock",data);

                    // if (!_.isEmpty(data)) {
                    //     appCtx.setMyBlockAccount(data);
                    // } else {
                    //     appCtx.setMyBlockAccount(appCtx.setMyBlockAccount);
                    // }
                    // if (!_.isEmpty(value)) {
                    //     let fs = data.filter((item: any) => {
                    //         console.log("item",item);

                    //         return item.toLowerCase().includes(value.toLowerCase());
                    //         // Object.values(item).join('').toLowerCase().includes(filesearchInput.toLowerCase())
                    //     });
                    //     appCtx.setMyBlockAccount(fs);
                    // } else {
                    //     appCtx.setMyBlockAccount(data);

                    // }
                    // const data = await loadMyFriend(value, callLimit, 0);
                    // if (!_.isEmpty(data)) {
                    //     appCtx.setMyBlockAccount(data);
                    // } else {
                    //     appCtx.setMyBlockAccount(appCtx.myFriends);
                    // }
                }
                if (appCtx.tabsFriends === "Reported History") {
                    // console.log("re");
                    // const res = await reportAPI.get(`&limit=${reportLimit}&offset=${reportedHistory.length}`);
                    // console.log("res",res);
                    
                    // const getReportedHistory = async () => {
                    //     const res = await reportAPI.get(`&limit=${reportLimit}&offset=${reportedHistory.length}`);
                    //     if (res?.code) return
                    //     setReportedHistory((prev) => [...prev, ...res?.reports]);
                    // };
                    // const data = await getReportedHistory(value, callLimit, 0);
                    // if (!_.isEmpty(data)) {
                    //     appCtx.setMyFriends(data);
                    // } else {
                    //     appCtx.setMyFriends(appCtx.myFriends);
                    // }
                }
            }, 500)
        );

        // appCtx.setMyFriends(fs);

    };

    return (
        <Layout className={styles.MyCenterMenuLayout}>
            <Header color={"light"} style={{
                backgroundColor: "white",
                padding: 0,
                lineHeight: 0,
                height: "100%",
                marginBottom: "2.5rem"
            }}>
                <div className={styles.leadContainer}>
                    <div className={styles.searchContainer}>
                        <div
                            className={styles.searchIcon}
                            style={{ backgroundImage: `url(${requestIcon.searchIcon})` }}
                        />
                        <input
                            type="text"
                            className={styles.searchInput}
                            placeholder={t("Search")}
                            onChange={(event) => {
                                searchFriends(event);
                            }}
                        />
                    </div>
                    <div>
                        {props.headerPostfix}
                    </div>
                </div>
            </Header>
            {children}
        </Layout>
    )
}

export default MyCenterMenuLayout;